var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZypp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 60,
    viewBox: "0 0 67.398 82.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 67.398,
    height: 82.066,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M17.248,127.659v9.954h7.842v-1.038H18.423v-8.916Z",
    transform: "translate(-7.505 -55.547)",
    fill: "#1a1818"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M57.654,136.651a4.3,4.3,0,0,1-.789.526,4.225,4.225,0,0,1-.907.341,4.376,4.376,0,0,1-1.081.123,3.96,3.96,0,0,1-1.739-.382,4.3,4.3,0,0,1-1.379-1.045,4.836,4.836,0,0,1-.913-1.564,5.834,5.834,0,0,1,0-3.865,5.01,5.01,0,0,1,.913-1.578,4.261,4.261,0,0,1,1.391-1.065,4.007,4.007,0,0,1,1.765-.39,4.841,4.841,0,0,1,1.075.11,4.167,4.167,0,0,1,.888.307,3.957,3.957,0,0,1,.758.478,6.813,6.813,0,0,1,.671.621l-.671.792a5.522,5.522,0,0,0-1.2-.942,3.252,3.252,0,0,0-2.87-.068,3.282,3.282,0,0,0-1.068.833,3.929,3.929,0,0,0-.708,1.25,4.6,4.6,0,0,0-.255,1.55,4.655,4.655,0,0,0,.255,1.557A3.915,3.915,0,0,0,52.5,135.5a3.365,3.365,0,0,0,1.068.84,2.945,2.945,0,0,0,1.336.307,3.1,3.1,0,0,0,1.541-.362,5.4,5.4,0,0,0,1.267-1.017l.646.7a6.349,6.349,0,0,1-.7.69",
    transform: "translate(-21.98 -55.588)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M71.616,137.58H70.5v-8.886H67.165v-1.035h7.783v1.035H71.616Z",
    transform: "translate(-29.225 -55.547)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M90.217,137.605l-2.774-3.842H84.711v3.842H83.632v-9.888h4.112a4.5,4.5,0,0,1,1.428.212,3.185,3.185,0,0,1,1.086.6,2.683,2.683,0,0,1,.7.933,2.9,2.9,0,0,1,.246,1.208,3.017,3.017,0,0,1-.191,1.109,2.543,2.543,0,0,1-.539.848,3.015,3.015,0,0,1-.826.6,3.735,3.735,0,0,1-1.038.339l2.937,4.038Zm-.739-8.34a2.818,2.818,0,0,0-1.808-.517H84.711v4.026h2.945a3.266,3.266,0,0,0,.986-.142,2.375,2.375,0,0,0,.781-.4,1.83,1.83,0,0,0,.513-.645,1.965,1.965,0,0,0,.185-.865,1.76,1.76,0,0,0-.643-1.453",
    transform: "translate(-36.39 -55.572)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 1.12,
    height: 9.921,
    transform: "translate(56.842 72.12)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M112.571,136.615a4.292,4.292,0,0,1-.789.526,4.226,4.226,0,0,1-.907.341,4.375,4.375,0,0,1-1.081.123,3.96,3.96,0,0,1-1.739-.382,4.3,4.3,0,0,1-1.379-1.045,4.836,4.836,0,0,1-.913-1.564,5.834,5.834,0,0,1,0-3.865,5.01,5.01,0,0,1,.913-1.578,4.261,4.261,0,0,1,1.391-1.065,4.007,4.007,0,0,1,1.765-.39,4.84,4.84,0,0,1,1.075.11,4.167,4.167,0,0,1,.888.307,3.956,3.956,0,0,1,.758.478,6.81,6.81,0,0,1,.671.621l-.671.792a5.523,5.523,0,0,0-1.2-.942,3.252,3.252,0,0,0-2.87-.068,3.282,3.282,0,0,0-1.068.833,3.929,3.929,0,0,0-.708,1.25,4.6,4.6,0,0,0-.255,1.55,4.655,4.655,0,0,0,.255,1.557,3.914,3.914,0,0,0,.708,1.256,3.365,3.365,0,0,0,1.068.84,2.945,2.945,0,0,0,1.336.307,3.1,3.1,0,0,0,1.541-.362,5.412,5.412,0,0,0,1.267-1.017l.646.7a6.35,6.35,0,0,1-.7.69",
    transform: "translate(-45.876 -55.572)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M.65,127.659H8.49A1.559,1.559,0,0,1,7.237,128.7H2.092S.919,128.5.65,127.659",
    transform: "translate(-0.283 -55.547)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M.65,127.659H8.49A1.559,1.559,0,0,1,7.237,128.7H2.092S.919,128.5.65,127.659",
    transform: "translate(-0.283 -55.547)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M.65,135.551H8.49a1.559,1.559,0,0,1-1.253,1.038H2.092s-1.173-.2-1.442-1.038",
    transform: "translate(-0.283 -58.981)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M.65,143.442H8.49a1.559,1.559,0,0,1-1.253,1.038H2.092s-1.173-.2-1.442-1.038",
    transform: "translate(-0.283 -62.414)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M33.845,127.659h7.84a1.559,1.559,0,0,1-1.253,1.038H35.287s-1.173-.2-1.442-1.038",
    transform: "translate(-14.727 -55.547)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M33.845,127.659h7.84a1.559,1.559,0,0,1-1.253,1.038H35.287s-1.173-.2-1.442-1.038",
    transform: "translate(-14.727 -55.547)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M33.845,135.551h7.84a1.559,1.559,0,0,1-1.253,1.038H35.287s-1.173-.2-1.442-1.038",
    transform: "translate(-14.727 -58.981)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M33.845,143.442h7.84a1.559,1.559,0,0,1-1.253,1.038H35.287s-1.173-.2-1.442-1.038",
    transform: "translate(-14.727 -62.414)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M38.069,24.448,27.892,12.366a20.682,20.682,0,0,0,12.037,34.1l3.462,5.993,3.461-5.993a20.658,20.658,0,0,0,11.683-6.3L29.483,27.742Z",
    transform: "translate(-9.875 -5.381)",
    fill: "#1fcd5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M48.394,0a20.619,20.619,0,0,0-14.2,5.645L62.3,18.059l-8.585,3.293L64.594,33.559A20.685,20.685,0,0,0,48.394,0",
    transform: "translate(-14.879 0)",
    fill: "#1fcd5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M30.094,7.9,24.77,5.183,28.795,9.24,26.517,6.49Z",
    transform: "translate(-10.778 -2.255)",
    fill: "#49aa4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M86.142,60.636l5.342,2.59L87.2,59.408,89.675,62Z",
    transform: "translate(-37.482 -25.849)",
    fill: "#49aa4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M3.4,95.176h6.777l-9.166,7.9L0,106.843H14.541l1.172-4.409H8.66l9.188-7.9,1.011-3.767H4.594Z",
    transform: "translate(0 -39.494)",
    fill: "#1fcd5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M45.707,90.767l-4.181,5.374-1.309-5.374H34.566l3.147,9.944-1.631,6.132h5.375l1.47-5.465,9.143-10.61Z",
    transform: "translate(-15.04 -39.494)",
    fill: "#1fcd5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M75.671,92.536c-1.194-1.194-3.009-1.769-5.973-1.769H64.3l-4.319,16.076h5.375l1.172-4.364H68.8c5.1,0,8.132-2.687,8.132-6.706a4.449,4.449,0,0,0-1.264-3.238m-7.144,6.109h-.965l.942-3.582h1.011a2.332,2.332,0,0,1,1.608.5,1.338,1.338,0,0,1,.391.942c0,1.217-.942,2.136-2.987,2.136",
    transform: "translate(-26.099 -39.494)",
    fill: "#1fcd5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M104.34,92.536c-1.194-1.194-3.009-1.769-5.972-1.769h-5.4L88.65,106.843h5.375l1.172-4.364h2.274c5.1,0,8.132-2.687,8.132-6.706a4.447,4.447,0,0,0-1.264-3.238M97.2,98.644h-.965l.942-3.582h1.011a2.33,2.33,0,0,1,1.608.5,1.336,1.336,0,0,1,.391.942c0,1.217-.942,2.136-2.986,2.136",
    transform: "translate(-38.573 -39.494)",
    fill: "#1fcd5b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZypp);
export default __webpack_public_path__ + "static/media/zypp.4a08358db6c599adac28bc435e090e79.svg";
export { ForwardRef as ReactComponent };